import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyx, silverChalice} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    paddingTop: 16,
    paddingBottom: 16,
    flexDirection: 'column',
  },
  label: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: indent - 15,
  },
  arrowIcon: {
    color: silverChalice,
    fontSize: 18,
    paddingLeft: 15,
    alignSelf: 'center',
  },
  carrot: {
    display: 'flex',
    flexDirection: 'row',
  },
  text: {
    color: onyx,
  },
});
